import { Platform, StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    paddingHorizontal: 16,
  },
  title: theme => ({
    color: theme.colors.rememberMeText,
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: 0,
  }),
  titlePriceContainer: {
    marginTop: Platform.OS === 'ios' ? 28 : 20,
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  price: theme => ({
    color: theme.colors.rememberMeText,
    fontSize: 42,
    fontFamily: Fonts.type.VodafoneLt,
  }),
  monthStyle: theme => ({
    color: theme.colors.rememberMeText,
    fontSize: 28,
    fontFamily: Fonts.type.VodafoneLt,
    marginBottom: 2,
  }),
});
